import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { useSnapshot } from 'valtio';

import { Button } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';

import { useBreakpoints } from '@/hooks';

import { store } from '../../store';

import { DateRangeFilter } from './DateRangeFilter';
import { TemperatureAndPowerWidget } from './EventContext';
import { ReeferKPI } from './ReeferKpi';

interface Props {
  setOpen: (open: boolean) => void;
}
export const Context = ({ setOpen }: Props) => {
  const { filtered: poFilterd } = useSnapshot(store.powerOutages);
  const { filtered: tbFiltered } = useSnapshot(store.temperatureBreaches);
  const { showGps } = useSnapshot(store.layout);
  const { reeferId } = useSnapshot(store);
  const { t } = useTranslation();

  const { useUp } = useBreakpoints();

  return (
    <Box sx={styles.container}>
      <Box sx={styles.filters}>
        <Button
          variant={reeferId ? 'contained' : 'outlined'}
          size="small"
          endIcon={<SearchIcon />}
          onClick={() => setOpen(true)}
          sx={{ textWrap: 'nowrap' }}
        >
          {reeferId ? `${reeferId}` : t('reeferInsights.selectReefer')}
        </Button>
        <DateRangeFilter />
      </Box>
      {!showGps && (
        <Box sx={styles.reeferInfo}>
          {/* <ReeferCard id={'test'} brand={'ok'} /> */}
          {/* <LegPieChart
          data={[
            { name: 'Vessel', value: 40 },
            { name: 'Logistic Site', value: 30 },
            { name: 'Train', value: 30 },
          ]}
        /> */}
          <ReeferKPI />
          <TemperatureAndPowerWidget
            powerOutageCount={poFilterd.length}
            temperatureBreachCount={tbFiltered.length}
          />
        </Box>
      )}
    </Box>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',

    p: 2,
    gap: 2,
  },
  title: { padding: 0 },
  filters: {
    flexDirection: 'row',
    display: 'flex',
    gap: 2,
    p: 2,
    backgroundColor: 'white',
    borderRadius: '20px',
  },
  reeferInfo: {
    flex: 1,
    gap: 2,
    display: 'flex',
  },
};
